const GetNavigationButtons = (selectedStudies, studyPageFilters, oralCareORSkinCleansingOrHairCareOrSkinCare, isHairCare, isUnileverFragranceHouse) => {
    let btnArr = [];
    if (selectedStudies.length > 0) {
        const hasFragrance = selectedStudies.every((study) => study.study_type__title.toLowerCase() === process.env?.REACT_APP_FRAGRANCE_TESTING?.toLowerCase());
        if (isUnileverFragranceHouse) {
            const defaultTitle = selectedStudies[0].study_type_method__default_title?.replace(/\s+/g, "")?.toLowerCase();
            if (defaultTitle === "clt") {
                btnArr = ["fragranceMetricsAnalysisCLT", "fragranceAssociationCLT", "agreementkpiClt"];
            } else {
                btnArr = ["overallKpi", "agreementKpi", "justRight", "correlation"];
            }
        } else if (hasFragrance) {
            const defaultTitle = selectedStudies[0].study_type_method__default_title?.replace(/\s+/g, "")?.toLowerCase();
            if (defaultTitle === "clt") {
                btnArr = ["fragranceMetricsAnalysisCLT", "preferenceAnalysis", "fragranceAssociationCLT", "agreementkpiClt", "productPreferenceAnalysis"];
            } else if (defaultTitle === "expressclt" || defaultTitle === "concepttesting") {
                btnArr = ["fragranceMetricsAnalysisExpressCLT", "preferenceAnalysis", "fragranceAssociation", "agreementKpi", "productPreferenceAnalysisExpressCLT"];
            } else {
                btnArr = ["fragranceMetricsAnalysis", "preferenceAnalysis", "fragranceAssociation", "agreementKpi", "productPreferenceAnalysis"];
            }
        } else {
            btnArr = oralCareORSkinCleansingOrHairCareOrSkinCare ? ["overallKpi", "agreementKpi", "justRight", "claims", ...(isHairCare ? ["fragranceDriver"] : []), "correlation",] : ["overallKpi", "agreementKpi", "claims", "correlation"];
        }
    } else {
        const hasFragrance = studyPageFilters?.studyType?.every((ele) => (ele.label.toLowerCase() === process.env?.REACT_APP_FRAGRANCE_TESTING?.toLowerCase() ? ele.checked : !ele.checked));
        const homeBtns = oralCareORSkinCleansingOrHairCareOrSkinCare ? ["overallKpi", "agreementKpi", "justRight", "claims", ...(isHairCare ? ["fragranceDriver"] : []), "correlation",] : ["overallKpi", "agreementKpi", "claims", "correlation"];
        btnArr = hasFragrance ? (isUnileverFragranceHouse ? ["overallKpi", "agreementKpi", "justRight","correlation"] : ["fragranceMetricsAnalysis", "preferenceAnalysis", "fragranceAssociation", "agreementkpiClt", "productPreferenceAnalysis"]) : homeBtns;
    }
    return btnArr;
};

export default GetNavigationButtons;
